import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container:{
    backgroundColor: "#F2F3F7",
    border: `1px solid #F2F3F7`,
    borderRadius: "5px",
    padding: '28px 20px 26px 20px',
    margin: "28px 18px 0 18px",
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.background.white
    }
  },
  textField: {
    marginTop: "8px",
    background: '#F2F3F7',
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  formLabel: {
    display: "inline-block",
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500,
    whiteSpace:'nowrap',
    height: '16px',
    minWidth: '1px'
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  dateSeperator: {
    color: theme.palette.grey.grey500,
    fontSize: '14px',
    margin: '0 9px',
    lineHeight: '37px'
  },
  filters: {
    marginTop: 0,
    marginLeft: 0
  },
  advancedFilters: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '25px',
    marginLeft: '0px',
    background: 'rgba(255,255,255,0.5)',
    borderRadius: '5px',
    padding: '16px',
    width: '100%'
  },
  placeHolder: {
    color: theme.palette.grey.grey400,
    fontSize: '14px'
  },
  searchButtons: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '25px',
  },
  crossBtn: {
    fontSize: "1rem",
    fontWeight: 500,
    marginRight: ".5rem",
  },
  attributFilterWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: '10px'
  },
  expandSearchButton: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '37px',
    marginTop: '8px',
    fontSize: '10px',
    textTransform: 'uppercase',
    color: theme.palette.grey.grey500,
    cursor: 'pointer',
    justifySelf: 'flex-end',
    paddingRight: '16px',
    '& img': {
      marginLeft: '2px'
    }
  }

}));

export default useStyles;
